<template>
  <div id="app">
    <router-view />
    <Maintenance :key="$route.fullPath" />
  </div>
</template>

<script>
import appConfig from "@/app.config";
import Maintenance from "./components/announcement/maintenance.vue";

export default {
  name: "app",
  components: { Maintenance },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  }
};
</script>
